import React, {PureComponent} from 'react'
import styled from 'styled-components'



const Card = styled.div`
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 15px 25px;
  border-radius: 4px;
  box-shadow: -2px 2px 17px -10px rgb(0 0 0 / 75%)
`

const Container = styled.div`
  width: 100%;
  position: absolute;
  padding:15px;
  z-index: 9999;
  bottom: 10px;
  // background: #000;
  margin: auto;
`

const Title = styled.h2`
  color: #020266;
  margin: 0;
  width: 100%;
  padding-bottom:30px;
`
const Circle = styled.div`
  position: relative;
  width: 50px;
  height: 50px;
  border-radius:50%;
  overflow:hidden;
  & img{
    width:100%;
  }
`
const AppDetails = styled.div`
  position: relative;
  padding-left:20px;

  & div:first-child{
    color: #686868;
    padding-top: 5px;
    font-weight: 600;
    padding-bottom: 7px;
  }
  & div:last-child{
    padding-bottom: 7px;
    font-size: 12px;
    font-style: italic;
  }

  & button{
    background: none;
    border: none;
    text-transform: uppercase;
    color: #1d1dec;
    font-weight: 600;
    font-size: 15px;
    margin-left: 20px;
  }
`

const Content = styled.div`
    display:flex;
`



class AddToHome extends PureComponent{
  state={
    open: false
  }
  render(){
    const {style}=this.props
    return(
      <Container style={{...style}}>
        <Card>
          <Title>Add to Home screen</Title>
          <Content>
            <Circle>
              <img alt='PMAY-U Logo' src={require('../static/logo-2.png')}/> 
            </Circle>
            <AppDetails>
              <div>Inspection</div>
              <div>https://dashboard.pmay-urban.gov.in/visitor</div>
            </AppDetails>
          </Content>      
          <AppDetails style={{display:'flex', justifyContent:'flex-end', paddingTop:20}}>
              <button>Cancel</button>
              <button>Add</button>
            </AppDetails>
        </Card>
      </Container>
     
    )
  }
}

export default AddToHome